import React from 'react';

import { IComponent } from '../../../typings/generic-component';
import { RaceSessionType, freePractices } from '../../../typings/race-session';
import { getSessionLabels } from '../../../utils/motorsports';
import { makeClassNames } from '../../../utils/styles';
import { dateFormat } from '../../../utils/times';
import StaticLinksContainer from '../../molecules/static-links-container/static-links-container';
import './lgp-preview.scss';

export interface ILGPPreview extends IComponent {
  gpName: string;
  sessions: {
    sessionName: RaceSessionType;
    date: string;
  }[];
  links: { text: string; link: string }[];
  sportLabel: 'F1' | 'MOTOGP' | 'MOTO2' | 'MOTO3';
}

const classNames = () =>
  makeClassNames({
    lgpPreview: 'lgp-preview',
    lgpPreviewHr: 'lgp-preview__hr',
    lgpPreviewH1: 'lgp-preview__h1',
    lgpPreviewH2: 'lgp-preview__h2',
    ctaContainer: 'cta-container',
  });

const cn = classNames();

const labels = getSessionLabels();

const getSportName = (sportLabel: string) => {
  switch (sportLabel) {
    case 'F1':
      return 'Formula 1';
    case 'MOTOGP':
      return 'MotoGP';
    case 'MOTO2':
      return 'Moto2';
    case 'MOTO3':
      return 'Moto3';
    default:
      return '';
  }
};

const LGPPreview = ({ gpName, sessions, links, sportLabel }: ILGPPreview) => {
  return (
    <div className={cn.lgpPreview}>
      <h1 className={cn.lgpPreviewH1}>Preview GP: {gpName}</h1>
      Il <b>{gpName}</b> è uno degli appuntamenti più attesi della stagione di {getSportName(sportLabel)}, con piloti e
      team che si preparano a sfidarsi su uno dei circuiti più caratteristici del calendario. Questo weekend di gara
      promette grande spettacolo, con numerosi elementi tecnici e strategici che influenzeranno l’esito finale. Ecco
      tutto ciò che c’è da sapere su <b>orari</b>, <b>classifiche</b>, <b>calendario</b>, <b>qualifiche</b>,{' '}
      <b>griglia di partenza</b>, <b>risultati</b>, <b>prove libere</b> e <b>dove seguire la gara</b> in diretta.
      <hr className={cn.lgpPreviewHr} />
      <h2 className={cn.lgpPreviewH2}>Programma del weekend: orari e prove libere</h2>
      Il weekend del <b>{gpName}</b> segue il consueto schema, con le sessioni di <b>prove libere</b>, <b>qualifiche</b>{' '}
      e la <b>gara</b> che si svolgeranno secondo i seguenti orari (ora italiana):
      <ul>
        {sessions?.map(({ sessionName, date }) => (
          <li key={date}>
            <b>
              {freePractices.includes(sessionName) ? 'Prove ' : ''}
              {labels[sessionName]}
            </b>
            : {dateFormat({ date, format: 'dddd D' })} ore {dateFormat({ date, format: 'hh:mm' })}
          </li>
        ))}
      </ul>
      Puoi seguire tutte le sessioni in diretta su <b>Sky Sport {sportLabel === 'F1' ? 'F1' : 'MotoGP'}</b>, il canale
      dedicato che ti porta nel cuore dell&apos;azione con commenti esperti, analisi dettagliate e interviste esclusive.
      <StaticLinksContainer links={links} />
    </div>
  );
};

export default LGPPreview;
